import { API_BASE_URL } from 'src/config/apiBase';
import { decryptToken } from '../Components/utils/getToken';

export async function openExpenseReceipt(filename) {
  if (!filename) return;
  if (filename.startsWith('http')) {
    window.open(filename, '_blank', 'noopener,noreferrer');
    return;
  }

  const token = decryptToken('accessToken') || '';
  const res = await fetch(
    `${API_BASE_URL}/api/expenses/receipt/${encodeURIComponent(filename)}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );

  if (!res.ok) {
    throw new Error('Failed to load receipt');
  }

  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);
  window.open(objectUrl, '_blank', 'noopener,noreferrer');
  setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
}

export function ExpenseReceiptLink({ filename, label = 'View', className = '' }) {
  if (!filename) return null;

  const handleClick = async (e) => {
    e.preventDefault();
    try {
      await openExpenseReceipt(filename);
    } catch {
      alert('Could not open receipt.');
    }
  };

  return (
    <button type="button" className={className} onClick={handleClick} style={{ background: 'none', border: 'none', padding: 0, color: '#007bff', textDecoration: 'underline', cursor: 'pointer' }}>
      {label}
    </button>
  );
}
